import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: '홈', path: '/' },
    { name: '포트폴리오', path: '/portfolio' },
    // { name: 'Case Studies', path: '/case-studies' }, // 임시 비활성화
  ];

  const menuItems = [
    { name: '홈', path: '/' },
    { name: '포트폴리오', path: '/portfolio' },
    { name: '케이스 스터디', path: '/case-studies' },
    { name: '문의하기', path: '/#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/90 backdrop-blur-xl border-b border-white/10 shadow-2xl shadow-black/50'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="group flex items-center space-x-3 cursor-pointer">
            <div className="relative">
              <div className="absolute inset-0 bg-[#F6B766]/20 rounded-lg blur-lg group-hover:bg-[#F6B766]/30 transition-all"></div>
              <div className="relative w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-black rounded-lg border border-[#F6B766]/30">
                <img
                  src="https://public.readdy.ai/ai/img_res/256ede9f9b173fcf539dd5f4762bc6bd.jpg"
                  alt="MondayPawn Logo"
                  className="w-8 h-8 object-cover rounded opacity-90"
                />
              </div>
            </div>
            <span className="text-2xl font-light text-white tracking-tight">
              MondayPawn
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => {
                  if (item.href.startsWith('/')) {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE(item.href);
                  }
                }}
                className="text-white/70 hover:text-[#F6B766] transition-colors font-light tracking-wide cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              className="px-6 py-2.5 bg-gradient-to-r from-[#F6B766] to-[#F4A259] text-black font-semibold rounded-full hover:shadow-lg hover:shadow-[#F6B766]/30 transition-all whitespace-nowrap cursor-pointer"
            >
              Start Project
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white hover:text-[#F6B766] transition-colors cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-6 border-t border-white/10 bg-black/95 backdrop-blur-xl">
            <nav className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => {
                    if (item.href.startsWith('/')) {
                      e.preventDefault();
                      window.REACT_APP_NAVIGATE(item.href);
                    }
                    setIsMobileMenuOpen(false);
                  }}
                  className="text-white/70 hover:text-[#F6B766] transition-colors font-light py-2 cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="inline-block text-center px-6 py-3 bg-gradient-to-r from-[#F6B766] to-[#F4A259] text-black font-semibold rounded-full hover:shadow-lg hover:shadow-[#F6B766]/30 transition-all whitespace-nowrap cursor-pointer"
              >
                Start Project
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
